
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Dashboard.module.css';

function Dashboard() {
  useEffect(() => {
    const cards = document.querySelectorAll(`.${styles.card}`);
    cards.forEach((card, index) => {
      setTimeout(() => {
        card.classList.add(styles.appear);
      }, index * 200);
    });
  }, []);

  return (
    <div className={styles.dashboard}>
      <h1 className={styles.title}>Welcome to Enrichify</h1>
      <div className={styles.cardGrid}>
        <Link to="/settings" className={styles.card}>
          <i className="fas fa-people-group"></i>
          <h2>Connect Discord</h2>
          <p>Link your Discord account to access our powerful betting tools and community features</p>
        </Link>
        
        <Link to="/calculators/back-lay" className={styles.card}>
          <i className="fas fa-calculator"></i>
          <h2>Betting Calculators</h2>
          <p>Access our suite of calculators for quick and accurate betting computations</p>
        </Link>

        <Link to="/bookie-database" className={styles.card}>
          <i className="fas fa-database"></i>
          <h2>Bookmaker Database</h2>
          <p>Find your next ideal bookmaker based on comprehensive analysis</p>
        </Link>

        <Link to="/settings" className={styles.card}>
          <i className="fas fa-user-cog"></i>
          <h2>Profile Settings</h2>
          <p>Manage your account preferences and customize your experience</p>
        </Link>
      </div>
    </div>
  );
}

export default Dashboard;
